import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const STORY_ENDPOINT = 'api/v1/admin/story_collections';

function getStoryCollections() {
  return api.get(`${baseUrl}/${STORY_ENDPOINT}`, {});
}

function getStoryCollectionDetail(collectionId: string) {
  return api.get(`${baseUrl}/${STORY_ENDPOINT}/${collectionId}`, {});
}

function createCollection(data: any) {
  return api.createWithFile(`${baseUrl}/${STORY_ENDPOINT}`, data);
}

function updateCollection(id: string, data: any) {
  return api.updateWithFilePut(`${baseUrl}/${STORY_ENDPOINT}/${id}`, data);
}

export {
    getStoryCollections,
    getStoryCollectionDetail,
    createCollection,
    updateCollection
}